import script from "./Options.vue?vue&type=script&setup=true&lang=ts"
export * from "./Options.vue?vue&type=script&setup=true&lang=ts"

import "./Options.vue?vue&type=style&index=0&id=70cc433f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70cc433f"]])

export default __exports__